import { render } from "./PostVinNumber.vue?vue&type=template&id=3c715872&scoped=true&ts=true"
import script from "./PostVinNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostVinNumber.vue?vue&type=script&setup=true&lang=ts"

import "./PostVinNumber.vue?vue&type=style&index=0&id=3c715872&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src444904090/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c715872"],['__file',"src/components/abrs/PostVinNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c715872"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c715872', __exports__)) {
    console.log('reload')
    api.reload('3c715872', __exports__)
  }
  
  module.hot.accept("./PostVinNumber.vue?vue&type=template&id=3c715872&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3c715872', render)
  })

}


export default __exports__